var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ibox',{attrs:{"title":'Przymierzalnia'},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var setLoading = ref.setLoading;
return [_c('data-tables',{attrs:{"url":("vnfr/" + (_vm.$route.params.env) + "/shopping-cards/list"),"columns_list":_vm.columns_list},on:{"loading":setLoading}})]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }